import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  signal,
  viewChild
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ITroubleshootingForm } from "src/app/interfaces/interfaces";
import { ExtenderService } from "src/app/services/extender.service";
import { FileService } from "src/app/services/file.service";
import { FormService } from "src/app/services/form.service";
import { IconService } from "src/app/services/icon.service";
import { TextAreaComponent } from "../../inputs/text-area/text-area.component";

import { IconComponent } from "../icon/icon.component";
import { ButtonComponent } from "../../inputs/button/button.component";
import { CheckboxCardComponent } from "../checkbox-card/checkbox-card.component";
import { ViewMoreComponent } from "../view-more/view-more.component";
import { TranslateModule } from "@ngx-translate/core";
import { Store } from "@ngrx/store";
import { clearFile, uploadFileFailure, uploadFileSuccess } from "src/app/state";
import { FileParameter, SwaggerException } from "src/domain/client";

@Component({
  selector: "app-fault-report",
  templateUrl: "./fault-report.component.html",
  imports: [
    TextAreaComponent,
    IconComponent,
    ButtonComponent,
    CheckboxCardComponent,
    ViewMoreComponent,
    TranslateModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FaultReportComponent implements OnInit {
  private fileId: string | null = null;
  public uploadError = signal<string | null>(null);
  fileUploadElementRef = viewChild<ElementRef>(
    "troubleshooting_file_upload"
  );

  constructor(
    public formService: FormService,
    public extenderService: ExtenderService,
    public iconService: IconService,
    public fileService: FileService,
    private store: Store
  ) {}

  ngOnInit(): void {}

  get troubleshootingForm(): FormGroup<ITroubleshootingForm> {
    return this.formService.chooseSpecificationsForm.controls
      .troubleshootingForm;
  }

  getTroubleshootingIconsForm(): FormGroup<any> {
    return this.troubleshootingForm.controls.icons;
  }

  onTroubleshootingFileChanged(event: any): void {
    if (event.target.files?.length) {
      const [newFile] = event.target.files;
      this.uploadError.set(null);
      if (newFile.size > 30000000) {
        this.troubleshootingForm.get("file").setErrors({ large: true });
        return;
      }
      // Reads the file into a FileParameter and also converts image to blob
      const reader = new FileReader();
      reader.onload = () => {
        const fileParameter: FileParameter = {
          data: new Blob([reader.result as ArrayBuffer], {
            type: newFile.type
          }),
          fileName: newFile.name
        };
        this.fileService
          .uploadFile(fileParameter)
          .then((fileId) => {
            this.fileId = fileId;
            this.store.dispatch(uploadFileSuccess({ fileId }));
          })
          .catch((error) => {
            if (error instanceof SwaggerException && error.status === 415) {
              this.uploadError.set("fault-report.file-type-error");
            } else {
              this.store.dispatch(uploadFileFailure({ error }));
            }
          });
      };
      this.troubleshootingForm.patchValue({
        file: newFile
      });
      reader.readAsArrayBuffer(newFile);
    }
  }
  onTroubleshootingFileClear(): void {
    this.troubleshootingForm.patchValue({
      file: null
    });
    this.uploadError.set(null);
    this.fileService.clearFile(this.fileId);
    this.store.dispatch(clearFile({ fileId: this.fileId }));
  }

  handleFileUpload(): void {
    this.fileUploadElementRef().nativeElement.click();
  }
}
